import { password } from '@iobroker/js-controller-common';

export default password;
